import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Search, Close } from '@mui/icons-material';

export default function SearchBar({ value, onChange, onClear, placeholder = 'Search episodes...' }) {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      size="medium"
      sx={{
        minWidth: 0,
        '& .MuiOutlinedInput-root': {
          bgcolor: 'background.paper',
          borderRadius: 3,
          '&:hover': {
            boxShadow: 2
          },
          '&.Mui-focused': {
            boxShadow: 3
          }
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search color="primary" />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={onClear}
              color="primary"
              aria-label="Clear search"
            >
              <Close />
            </IconButton>
          </InputAdornment>
        )
      }}
      inputProps={{ 'aria-label': placeholder, type: 'search' }}
    />
  );
}
